import React from 'react';

import { setLanguageToI18n } from 'locales';

const useLocales = (): void => {
  React.useEffect(() => {
    setLanguageToI18n();
  }, []);
};

export default useLocales;
